interface MetricBarProps {
  label: string;
  value: number;
  unit?: string;
  tone?: 'default' | 'success' | 'warning' | 'critical';
}

export function MetricBar({ label, value, unit = '%', tone = 'default' }: MetricBarProps) {
  const boundedValue = Math.max(0, Math.min(100, value));
  return (
    <div className="metric-bar">
      <div className="metric-bar__header">
        <span>{label}</span>
        <strong>{Math.round(value)}{unit}</strong>
      </div>
      <div
        className="metric-bar__track"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(boundedValue)}
      >
        <span className={`metric-bar__fill metric-bar__fill--${tone}`} style={{ width: `${boundedValue}%` }} />
      </div>
    </div>
  );
}
